module.exports = __webpack_public_path__ + "static/media/pdfIcon.ebda810c.png";